export default {
    firstToCreate: 'Seja o primeiro a criar um tópico neste fórum',
    firstToPostInCategory: 'Seja o primeiro a postar nesta categoria',
    firstToRespondToTopic: 'Seja o primeiro a responder a este tópico!',
    createNewThread: 'Criar novo tópico',
    thread: 'tópico',
    viewThread: 'Ver tópico',
    replies: 'Respostas',
    noReplies: 'Sem respostas',
    reply: 'responder',
    _reply: 'Responder',
    ReplyTo: 'Responder a',
    replyToThisQuestion: 'Responder a esta pergunta',
    onceRepliedModeratorMayRespond: 'Assim que você responder, o moderador do fórum poderá responder à sua resposta',
    onceRepliedCanViewResponses: 'Assim que você responder, poderá ver as respostas de outros participantes',
    loadingResponses: 'Carregando respostas',
    hideXReplies: 'Ocultar {count} respostas',
    showXReplies: 'Mostrar {count} respostas',
    hideMostRecentReplies: 'Ocultar as respostas mais recentes',
    showMostRecentReplies: 'Mostrar as respostas mais recentes',
    post: 'Publicar',
    message: 'Mensagem',
    typeMessage: 'Digite uma mensagem',
    addPost: 'Adicionar publicação',
    addMessage: 'Adicionar mensagem',
    editPost: 'Editar publicação',
    editPostWithMedia: 'Editar publicação com mídia',
    createPostWithMedia: 'Criar publicação com mídia',
    deleteMessage: 'Excluir mensagem',
    deleteMessageConfirm: 'Tem certeza de que deseja excluir esta mensagem?',
    pinPost: 'Fixar publicação',
    media: 'Mídia',
    uploadMedia: 'Carregar mídia',
    categories: 'categorias',
    goBack: 'Voltar',
    goBackPrevious: 'Voltar para a página anterior',
    goBackToCategory: 'Voltar para a categoria {name}',
    loadingLatestThreads: 'Carregando os tópicos mais recentes',
    loadingDiscussionForum: 'Carregando o fórum de discussão',
    dontShowAgainForTask: 'Não mostrar novamente para esta tarefa',
    title: 'Título',
    beTheFirst: 'Seja o primeiro a responder a este tópico'
};
